// @flow
import styled from "styled-components"

export const CheckboxWrap = styled.div`
  margin-left: 1rem;
`



// WEBPACK FOOTER //
// ./src/searchFilters/FilterComponents/PassportFilter/styled.js